import React from "react";
import styles from "./style.module.scss";

const TitleContainer = ({ title = "" }) => {
  return (
    <div className={styles.container}>
      <div className={styles.left} />
      <div className={styles.text}>{title}</div>
      <div className={styles.right} />
    </div>
  );
};

export default TitleContainer;
